import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import { format } from 'date-fns';
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBIcon,
  MDBInput,
  MDBModal,
  MDBModalHeader,
  MDBModalBody,
  MDBModalFooter,
} from 'mdbreact';
import { toast } from 'react-toastify';

import NavBar from '../../../../components/NavBar';
import api from '../../../../services/api';

export default function CadastrarMulta() {
  const history = useHistory();

  // viaturas de TODAS as gerencias (sem gerencia_id o backend retorna todas)
  const [listaVtrs, setListaVtrs] = useState([]);
  const [vtrSelecionada, setVtrSelecionada] = useState(null);

  const [dataHora, setDataHora] = useState('');
  const [valor, setValor] = useState('');
  const [emissor, setEmissor] = useState('');
  const [numeroAuto, setNumeroAuto] = useState('');

  // REAL infrator, identificado pelo BDT selecionado na modal
  const [infrator, setInfrator] = useState(null); // { id, nome, id_funcional }
  const [bdtVinculado, setBdtVinculado] = useState(null);

  // modal de BDTs
  const [modalBdts, setModalBdts] = useState(false);
  const [bdts, setBdts] = useState([]);
  const [bdtSelecionado, setBdtSelecionado] = useState(null);
  const [buscando, setBuscando] = useState(false);
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    api
      .get('/frota', { params: { ativo: true } })
      .then(r =>
        setListaVtrs(
          (r.data || []).map(v => ({
            label: `${v.placa}${v.modelo ? ` — ${v.modelo}` : ''}`,
            value: v.id,
          }))
        )
      )
      .catch(() => toast.error('Falha ao carregar as viaturas'));
  }, []);

  const nomeDoUsuario = u =>
    u?.nome_social ||
    [u?.nome, u?.sobrenome].filter(Boolean).join(' ') ||
    '—';

  // trocar viatura/data-hora invalida o condutor ja carregado (o vinculo era
  // para aquela combinacao)
  const limpaInfrator = () => {
    setInfrator(null);
    setBdtVinculado(null);
  };

  const buscarBdts = async () => {
    setBuscando(true);
    try {
      const result = await api.get('/multa-busca-bdts', {
        params: { veiculo_id: vtrSelecionada.value, data_hora: dataHora },
      });
      setBdts(result.data || []);
      setBdtSelecionado(null);
      setModalBdts(true);
    } catch (e) {
      toast.error(e?.response?.data?.erro || 'Falha ao buscar os BDTs');
    }
    setBuscando(false);
  };

  // o BDT cobre o horario exato da multa?
  const cobreHorario = bdt => {
    const t = new Date(dataHora).getTime();
    const ini = new Date(bdt.data_apresentacao).getTime();
    const fim = bdt.data_dispensa
      ? new Date(bdt.data_dispensa).getTime()
      : Infinity;
    return t >= ini && t <= fim;
  };

  const dataHoraBR = v => {
    try {
      return format(new Date(v), 'dd/MM/yyyy HH:mm');
    } catch (e) {
      return '';
    }
  };

  const carregarCondutor = () => {
    const bdt = bdts.find(b => b.id === bdtSelecionado);
    if (!bdt) {
      toast.error('Selecione um BDT');
      return;
    }
    if (!bdt.usuario) {
      toast.error('BDT sem condutor identificado');
      return;
    }
    setInfrator({
      id: bdt.usuario.id,
      nome: nomeDoUsuario(bdt.usuario),
      id_funcional: bdt.usuario.id_funcional,
    });
    setBdtVinculado(bdt.id);
    setModalBdts(false);
  };

  const salvar = async () => {
    if (!vtrSelecionada || !dataHora) {
      toast.error('Informe a viatura e a data/hora da multa');
      return;
    }
    setSalvando(true);
    try {
      const result = await api.post('/multa', {
        fk_veiculos_id: vtrSelecionada.value,
        data_hora: dataHora,
        valor: valor === '' ? null : Number(valor),
        emissor,
        numero_auto: numeroAuto,
        fk_infrator_id: infrator ? infrator.id : null,
        fk_bdt_id: bdtVinculado,
      });
      if (result.data && result.data.erro) {
        toast.error(result.data.erro);
      } else {
        toast.success('Multa cadastrada!');
        history.push('/multas');
      }
    } catch (e) {
      toast.error(e?.response?.data?.erro || 'Falha ao cadastrar a multa');
    }
    setSalvando(false);
  };

  return (
    <NavBar>
      <MDBContainer className="my-4">
        <h3 className="h3-responsive text-center font-weight-bolder mb-4">
          Cadastrar Multa
        </h3>
        <MDBRow>
          <MDBCol size="12" md="6">
            <span className="grey-text">Viatura</span>
            <Select
              options={listaVtrs}
              placeholder="Placa — digite para buscar"
              value={vtrSelecionada}
              onChange={e => {
                setVtrSelecionada(e);
                limpaInfrator();
              }}
            />
          </MDBCol>
          <MDBCol size="12" md="6">
            <span className="grey-text">Data e hora da multa</span>
            <input
              type="datetime-local"
              className="form-control"
              value={dataHora}
              onChange={e => {
                setDataHora(e.target.value);
                limpaInfrator();
              }}
            />
          </MDBCol>
        </MDBRow>
        <MDBRow>
          <MDBCol size="12" md="4">
            <MDBInput
              label="Valor da multa (R$)"
              type="number"
              value={valor}
              onChange={e => setValor(e.target.value)}
            />
          </MDBCol>
          <MDBCol size="12" md="4">
            <MDBInput
              label="Emissor"
              value={emissor}
              onChange={e => setEmissor(e.target.value)}
            />
          </MDBCol>
          <MDBCol size="12" md="4">
            <MDBInput
              label="Nº do auto de infração"
              value={numeroAuto}
              onChange={e => setNumeroAuto(e.target.value)}
            />
          </MDBCol>
        </MDBRow>

        <hr />
        <p className="font-weight-bold">Real infrator (condutor no BDT)</p>
        <MDBRow className="align-items-center">
          <MDBCol size="12" md="6">
            {infrator ? (
              <div className="p-2 bg-light rounded">
                <b>{infrator.nome}</b>
                {infrator.id_funcional ? ` — Id ${infrator.id_funcional}` : ''}
              </div>
            ) : (
              <span className="font-italic grey-text">
                Não identificado — busque os BDTs da viatura na data/hora
              </span>
            )}
          </MDBCol>
          <MDBCol size="12" md="6">
            <MDBBtn
              color="mdb-color"
              size="sm"
              disabled={!vtrSelecionada || !dataHora || buscando}
              onClick={buscarBdts}
            >
              <MDBIcon icon="search" className="mr-2" />
              Buscar BDTs
            </MDBBtn>
          </MDBCol>
        </MDBRow>

        <MDBRow center className="mt-4">
          <MDBBtn color="success" disabled={salvando} onClick={salvar}>
            <MDBIcon far icon="save" className="mr-2" />
            Salvar Multa
          </MDBBtn>
        </MDBRow>
      </MDBContainer>

      {/* BDTs do veiculo no dia da multa: selecionar o que cobre o horario */}
      <MDBModal isOpen={modalBdts} toggle={() => setModalBdts(false)} size="lg">
        <MDBModalHeader toggle={() => setModalBdts(false)}>
          BDTs da viatura no dia da multa
        </MDBModalHeader>
        <MDBModalBody>
          {bdts.length === 0 ? (
            <p className="text-center font-italic">
              Nenhum BDT encontrado para o veículo neste dia. A multa pode ser
              salva sem infrator e identificada depois.
            </p>
          ) : (
            bdts.map(bdt => (
              <div
                key={bdt.id}
                onClick={() => setBdtSelecionado(bdt.id)}
                style={{ cursor: 'pointer' }}
                className={`p-2 mb-2 rounded border ${
                  bdtSelecionado === bdt.id ? 'border-primary bg-light' : ''
                }`}
              >
                <MDBRow>
                  <MDBCol size="1">
                    <input
                      type="radio"
                      checked={bdtSelecionado === bdt.id}
                      onChange={() => setBdtSelecionado(bdt.id)}
                    />
                  </MDBCol>
                  <MDBCol>
                    <b>{nomeDoUsuario(bdt.usuario)}</b>
                    {cobreHorario(bdt) && (
                      <span className="badge badge-success ml-2">
                        cobre o horário da multa
                      </span>
                    )}
                    <div style={{ fontSize: '12px' }}>
                      {dataHoraBR(bdt.data_apresentacao)} →{' '}
                      {bdt.data_dispensa
                        ? dataHoraBR(bdt.data_dispensa)
                        : 'em aberto'}
                      {' | KM '}
                      {bdt.quilometragem_inicio ?? '—'} →{' '}
                      {bdt.quilometragem_fim ?? '—'}
                    </div>
                  </MDBCol>
                </MDBRow>
              </div>
            ))
          )}
        </MDBModalBody>
        <MDBModalFooter>
          <MDBBtn
            color="secondary"
            size="sm"
            onClick={() => setModalBdts(false)}
          >
            Cancelar
          </MDBBtn>
          {bdts.length > 0 && (
            <MDBBtn
              color="primary"
              size="sm"
              disabled={!bdtSelecionado}
              onClick={carregarCondutor}
            >
              Carregar condutor
            </MDBBtn>
          )}
        </MDBModalFooter>
      </MDBModal>
    </NavBar>
  );
}
